import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import Search from "../../assets/img/core-img/search.png"
const Layout = (props: any) => {
  return (
    <>
    <div className="search-wrapper section-padding-100">
    <div className="search-close">
        <i className="fa fa-close" aria-hidden="true"></i>
    </div>
    <div className="container">
        <div className="row">
            <div className="col-12">
                <div className="search-content">
                    <form action="#" method="get">
                        <input type="search" name="search" id="search" placeholder="Type your keyword..."/>
                        <button type="submit"><img src={Search} alt=""/></button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<div className="main-content-wrapper d-flex clearfix">

   
    <Navbar/>

    
    {props.children}
    
</div>
    <Footer />
    <a id="scrollUp" href="#top" style={{position: "fixed", zIndex: "2147483647", display: "block"}}><i className="fa fa-angle-up" aria-hidden="true"></i></a>

    </>
  );
};

export default Layout;
